import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Fragment } from 'react';
import { Card, CardProps } from 'react-bootstrap';
import Button from '../Button';
import Link from '../Link';
import Switch from '../Switch';

export type PreferedCardVariant = 'default' | 'selected';

export type preferedCardProps = CardProps &
  React.PropsWithChildren<{
    variant?: PreferedCardVariant;
    title?: string;
    editButtonName?: string;
    isSwitch?: boolean;
    isDismissable?: boolean;
    switchLabel?: string;
    checked?: boolean;
    id?: string;
    switchName?: string;
    onDelete?: () => void;
    onEdit?: () => void;
    onButtonClick?: () => void;
    onSwitchChange?: () => void;
  }>;

const PreferedCard = ({
  variant = 'default',
  children,
  title,
  editButtonName,
  switchName,
  isSwitch = true,
  isDismissable = true,
  switchLabel = 'Preferred',
  checked,
  id,
  onDelete,
  onEdit,
  onButtonClick,
  onSwitchChange,
  ...props
}: preferedCardProps) => {
  return (
    <Card variant={variant} bsPrefix={'prefered-card'} {...props}>
      <Card.Body>
        <div
          className={`card-title text-fs-base fw-normal ${
            variant === 'selected' ? 'blue-title' : ''
          }`}
        >
          {title}
        </div>
        <div className={'custom-body-wrap mt-7 lh-xs'}>{children}</div>
        {variant === 'selected' && (
          <div className={'top-right-button'}>
            <Button onClick={onButtonClick} size={'sm'}>
              {'Change'}
            </Button>
          </div>
        )}
        {variant === 'default' && (
          <Fragment>
            {isDismissable && (
              <div className="top-right-icon" onClick={onDelete}>
                <FontAwesomeIcon icon={light('trash-can')} />
              </div>
            )}
            <section
              className={
                'd-flex justify-content-between w-100 align-items-center pt-7 mt-auto'
              }
            >
              <Link isBlue onClick={onEdit}>
                {editButtonName}
              </Link>
              {isSwitch && (
                <Switch
                  variant="sm"
                  label={switchLabel}
                  id={id}
                  isLeftLabel
                  onChange={onSwitchChange}
                  checked={checked}
                  name={switchName}
                />
              )}
            </section>
          </Fragment>
        )}
      </Card.Body>
    </Card>
  );
};

export default PreferedCard;
